module.exports = __webpack_public_path__ + "static/National2Web-RegularItalic-e2939b57ff7b70ddd11741aa5dadb9d5.woff";